export const STATUS_TRADING = "STATUS_TRADING";
export const SET_HOST_TRADER = "SET_HOST_TRADER";
export const SET_TRADING_FULL = "SET_TRADING_FULL";
export const SET_TRADE_OFERT_HOST = "SET_TRADE_OFERT_HOST";
export const SET_TRADE_OFERT_OPONENT = "SET_TRADE_OFERT_OPONENT";
export const SET_HOST_HENRY_COIN = "SET_HOST_HENRY_COIN";
export const SET_OPONENT_HENRY_COIN = "SET_OPONENT_HENRY_COIN";
export const SET_HOST_CONFIRMATION = "SET_HOST_CONFIRMATION";
export const SET_TARGET_CONFIRMATION = "SET_TARGET_CONFIRMATION";